import React, { useEffect, useState } from 'react';
import blogsData from '../data/blogs.json';
import BlogCard from '../components/blog/BlogCard';
const BlogsPage = () => {
    const [blogs, setBlogs] = useState([]);
  
    useEffect(() => {
      // Sort blogs by date in descending order (newest first)
      const sortedBlogs = blogsData.sort((a, b) => new Date(b.date) - new Date(a.date));
      setBlogs(sortedBlogs); // Update the state with the sorted blogs
    }, []);
  
    return (
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-6">Our Blogs</h1>
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 gap-2 md:gap-8">
          {blogs.map((blog) => (
            <BlogCard key={blog.id} blog={blog} />
          ))}
        </div>
      </div>
    );
  };
  
  export default BlogsPage;
